'use strict';
import config from './config.js'
import axios from '../src/request/http' //导入axios请求
/*
 * 配置编译环境和线上环境之间的切换
 * BASE_URL: 域名地址
 */
console.log('NOW_ENV', process.env.NODE_ENV)
let BASE_URL = '' //三七
let FINANCE_URL = '' //财务
let CONTRACT_URL = '' //合同
let SCREEN_URL = '' //一体机
let setUeUrl = '' //百度富文本
let BASE_PAOHE = '' //PAOHE的url
let SING_CONTRACT_USER_ID = '' //签属合同的用户id  目前各个环境都是一样的 20230906
if (process.env.NODE_ENV === 'development') {
  // BASE_URL = 'http://192.168.100.216:11002/jyh' // 三七zuul开发服务器开发
  // CONTRACT_URL = 'http://192.168.100.214:12001/contract' // paohe2.0 合同zuul开发服务器
  // SCREEN_URL = 'http://192.168.100.216:82' // 一体机开发环境
  // setUeUrl = 'http://192.168.100.36:21002/invoker'
  BASE_PAOHE = 'http://p3-zuul.paohe360.com'
  BASE_URL = 'http://183.6.187.59:8882/jyh' // 三七仿真环境
  FINANCE_URL = 'http://183.6.187.59:8880' // 业财一体化仿真环境
  CONTRACT_URL = 'http://183.6.187.59:8881/contract' // paohe2.0 合同仿真服务器开发
  SCREEN_URL = 'http://183.6.187.59:8877' // 一体机仿真环境
  setUeUrl = 'http://192.168.100.36:21002/invoker'
  SING_CONTRACT_USER_ID='100000000008574'
} else if (process.env.NODE_ENV === 'testing') {
  BASE_PAOHE = 'http://192.168.200.207:12001'
  BASE_URL = 'http://192.168.100.216:11002/jyh' // 三七测试
  FINANCE_URL = 'http://192.168.100.214:82/login' // 业财一体化测试
  CONTRACT_URL = 'http://192.168.100.214:12001/contract' // paohe2.0 合同测试服务器开发
  SCREEN_URL = 'http://192.168.100.216:82' // 一体机测试环境
  setUeUrl = 'http://192.168.100.36:21002/invoker'
  SING_CONTRACT_USER_ID='100000000008574'
} else if (process.env.NODE_ENV === 'production') {
  BASE_PAOHE = 'https://p2-zuul.paohe.cn' 
  BASE_URL = 'https://pm.paohe.cn/zuul/jyh' // 三七线上环境
  FINANCE_URL = 'https://finance.paohe.cn/login' // 业财一体化线上环境
  CONTRACT_URL = 'https://contract.paohe.cn/zuul/contract' // paohe2.0 合同服务器开发
  SCREEN_URL = 'https://pmscreen.paohe.cn' // 一体机线上环境
  setUeUrl = 'http://192.168.100.36:21002/invoker'
  SING_CONTRACT_USER_ID='100000000008574'
} else if (process.env.NODE_ENV === 'uat') {
  BASE_PAOHE = 'http://p3-zuul.paohe360.com'
  BASE_URL = 'http://183.6.187.59:8882/jyh' // 三七仿真环境
  FINANCE_URL = 'http://183.6.187.59:8880' // 业财一体化仿真环境
  CONTRACT_URL = 'http://183.6.187.59:8881/contract' // paohe2.0 合同仿真服务器开发
  SCREEN_URL = 'http://183.6.187.59:8877' // 一体机仿真环境
  setUeUrl = 'http://192.168.100.36:21002/invoker'
  SING_CONTRACT_USER_ID='100000000008574'
}


//导出
export {
  BASE_PAOHE,
  BASE_URL, //三七域名地址
  FINANCE_URL, //业财一体化地址
  CONTRACT_URL, //合同地址
  SCREEN_URL, // 一体机
  setUeUrl,
  SING_CONTRACT_USER_ID
}



//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = AMf1
// module chunks = 67